import { createSlice } from "@reduxjs/toolkit";
import { EmployeeProps } from "../types";

const initialState: EmployeeProps = {
  employeeDetails: null,
};

const employeeReducer = createSlice({
  name: "employee",
  initialState: initialState,
  reducers: {
    viewEmployee(state, action) {
      return {
        ...state,
        employeeDetails: action.payload,
      };
    },
  },
});

export default employeeReducer.reducer;

export const { viewEmployee } = employeeReducer.actions;
